/**
 * Created by JasonChou on 17/1/12.
 */
exports.isFunction = (o)=> {
    return Object.prototype.toString.call(o) === '[object Function]';
};

exports.isObject = (o)=> {
    return Object.prototype.toString.call(o) === '[object Object]';
};

exports.isNumber = (o)=> {
    return Object.prototype.toString.call(o) === '[object Number]';
};

exports.isString = (o)=> {
    return Object.prototype.toString.call(o) === '[object String]';
};

exports.isEmptyObject = (o) => {
  for (const item in o)
    return false;
  return true;
};

exports.isObjectId = (id)=> {
  const checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
  if (id == null) return false;

    if (typeof id === 'number') {
        return true;
    }

    if (typeof id === 'string') {
        return id.length === 12 || (id.length === 24 && checkForHexRegExp.test(id));
    }

    return false;
};



// WEBPACK FOOTER //
// ./src/utils/typeUtils.js